exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svgIcon[data-v-dae1fdca]{color:#a9b1c2;margin-left:2rem;:hover{color:#353d51}}.no-select[data-v-dae1fdca]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);

// exports
